module.exports = __webpack_public_path__ + "img/189.79378f5f.jpg";